import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalIdParts } from '@lib/services';
import { LoungeServiceRequestComponent } from './lounge-service-request.component';
import { LoungeServiceRequestHeaderComponent } from './lounge-service-request-header.component';
import { LoungeServiceRequestFooterComponent } from './lounge-service-request-footer.component';

export function loungeServiceRequestPayloadParts(): ModalIdParts {
  return {
    id: 'LoungeServiceRequestModal',
    header: LoungeServiceRequestHeaderComponent,
    footer: LoungeServiceRequestFooterComponent,
    content: LoungeServiceRequestComponent,
    closeBackEnable: false,
    type: ModalType.TYPE4,
    modalWidth: LModalContentsWidthType.NONE,
    payload: {
      screenInformationChangeFlag: false,
    },
  };
}
